<div [id]="idCard" style="min-height: 100px; width: 100%">
  <app-skeleton-card-vehicle
    *ngIf="!isObserverCard"
    (click)="stopEvent($event)"
  ></app-skeleton-card-vehicle>

  <article
    *ngIf="isObserverCard"
    class="card"
    (click)="onClickCard($event)"
    [class.card-active]="isExpanded"
  >
    <header>
      <div class="titles_container">
        <p
          class="title"
          (click)="
            copyToClipboard(primaryName, 'primaryName');
            $event.stopPropagation()
          "
          title="Haz clic para copiar"
          style="cursor: pointer; background-color: transparent"
          onmouseover="this.style.backgroundColor = '#e0ffe0'"
          onmouseout="this.style.backgroundColor = 'transparent'"
        >
          {{ primaryName }}
        </p>

        <p
          *ngIf="servicePanel.showImei$ | async"
          class="title_secondary"
          (click)="copyToClipboard(IMEI, 'IMEI'); $event.stopPropagation()"
          title="Haz clic para copiar"
          style="cursor: pointer; background-color: transparent"
          onmouseover="this.style.backgroundColor = '#e0ffe0'"
          onmouseout="this.style.backgroundColor = 'transparent'"
        >
          {{ IMEI }}
        </p>
      </div>

      <div class="dates_container">
        <i class="icon_header">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#000"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </i>
        <time
          [attr.datetime]="date ? date.toISOString() : null"
          (click)="copyDateText($event); $event.stopPropagation()"
          style="cursor: pointer; background-color: transparent"
          onmouseover="this.style.backgroundColor = '#e0ffe0'"
          onmouseout="this.style.backgroundColor = 'transparent'"
        >
          {{
            date ? (date | date: "dd/MM/yyyy 'a las' HH:mm:ss") : "Sin fecha"
          }}
        </time>
      </div>
    </header>

    <div class="location_container" [class.copiedLocation]="isCopyLocation">
      <p
        *ngIf="servicePanel.showNumSim$ | async"
        class="location"
        (click)="copyValueLocation($event)"
        (mouseleave)="hideTooltipLocation()"
      >
        {{ "VEHICLES.CARD.GENERAL.SIM" | translate }}: {{ location }}
        <i class="icon_location" *ngIf="location !== 'No disponible'">
          <svg
            class="icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 -960 960 960"
          >
            <path
              d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
            />
          </svg>
        </i>
      </p>
    </div>

    <main class="card_content">
      <div class="tabs_section">
        <app-tabs-vehicle
          *ngIf="servicePanel.showColorStatus$ | async"
          [variant]="variantTab"
        ></app-tabs-vehicle>
        <app-label-vehicle
          *ngIf="servicePanel.showIgnitionStatus$ | async"
          [style.backgroundColor]="hasIgnition ? '#313131' : 'transparent'"
          [style.color]="hasIgnition ? '#fff' : 'inherit'"
          style="border-radius: 4px"
        >
          <svg
            *ngIf="hasIgnition"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-power"
          >
            <path d="M12 2v10" />
            <path d="M18.4 6.6a9 9 0 1 1-12.77.04" />
          </svg>
          <svg
            *ngIf="!hasIgnition"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-power-off"
          >
            <path d="M18.36 6.64A9 9 0 0 1 20.77 15" />
            <path d="M6.16 6.16a9 9 0 1 0 12.68 12.68" />
            <path d="M12 2v4" />
            <path d="m2 2 20 20" />
          </svg>
        </app-label-vehicle>
        <app-label-vehicle
          *ngIf="servicePanel.showSpeed$ | async"
          [value]="speed.value"
          [unitMeasurement]="speed.measurement"
        >
          <i>
            <svg
              _ngcontent-iaq-c224=""
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
            >
              <path
                _ngcontent-iaq-c224=""
                fill="currentColor"
                d="M15.91 13.34l2.636-4.026-.454-.406-3.673 3.099c-.675-.138-1.402.068-1.894.618-.736.823-.665 2.088.159 2.824.824.736 2.088.665 2.824-.159.492-.55.615-1.295.402-1.95zm-3.91-10.646v-2.694h4v2.694c-1.439-.243-2.592-.238-4 0zm8.851 2.064l1.407-1.407 1.414 1.414-1.321 1.321c-.462-.484-.964-.927-1.5-1.328zm-18.851 4.242h8v2h-8v-2zm-2 4h8v2h-8v-2zm3 4h7v2h-7v-2zm21-3c0 5.523-4.477 10-10 10-2.79 0-5.3-1.155-7.111-3h3.28c1.138.631 2.439 1 3.831 1 4.411 0 8-3.589 8-8s-3.589-8-8-8c-1.392 0-2.693.369-3.831 1h-3.28c1.811-1.845 4.321-3 7.111-3 5.523 0 10 4.477 10 10z"
              ></path>
            </svg>
          </i>
        </app-label-vehicle>
        <app-label-vehicle
          *ngIf="servicePanel.batteryVoltage$ | async"
          [value]="batteryVoltage.value"
          [unitMeasurement]="batteryVoltage.measurement"
        ></app-label-vehicle>
        <app-label-vehicle
          *ngIf="
            amountOfFuel.value !== 0 && (servicePanel.showAmountOfFuel$ | async)
          "
          [value]="amountOfFuel.value"
          [unitMeasurement]="amountOfFuel.measurement"
        ></app-label-vehicle>
        <app-label-vehicle
          *ngIf="
            (servicePanel.showTimeElapsed$ | async) && variantTab !== 'inMotion'
          "
          [value]="' ' + timeElapsed"
        >
          <i class="fas fa-hourglass-half"></i>
        </app-label-vehicle>
        <app-label-vehicle
          *ngIf="servicePanel.showSatelliteCount$ | async"
          [value]="satelliteCount"
          [unitMeasurement]="'satélites'"
        >
          <i>
            <svg
              width="12"
              height="12"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                d="M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
              />
            </svg>
          </i>
        </app-label-vehicle>

        <ng-container *appHasPermission="'vehicles_options_teltonika'">
          <ng-container
            *ngIf="
              (servicePanel.showTemperatureBle$ | async) &&
              temperatureBLE.typeGps === 'teltonika'
            "
          >
            <ng-container [ngSwitch]="temperatureBLE.variant">
              <app-label-vehicle
                *ngSwitchCase="'cold'"
                [value]="temperatureBLE.value + ' °C'"
                style="border-radius: 4px; color: #00acc1"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-cold"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
              <app-label-vehicle
                *ngSwitchCase="'hot'"
                [value]="temperatureBLE.value + ' °C'"
                style="border-radius: 4px; color: #e53935"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-hot"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
              <app-label-vehicle
                *ngSwitchCase="'medium'"
                [value]="temperatureBLE.value + ' °C'"
                style="border-radius: 4px; color: #fb8c00"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-medium"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
              <app-label-vehicle
                *ngSwitchDefault
                style="background-color: white; border-radius: 4px"
                title="Temperatura no disponible"
              >
                <i>
                  <svg width="16" height="16" fill="#9e9e9e">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-disabled"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *appHasPermission="'vehicles_options_teltonika'">
          <ng-container
            *ngIf="
              (servicePanel.showTemperatureEye$ | async) &&
              temperatureEYE.typeGps === 'teltonika'
            "
          >
            <ng-container [ngSwitch]="temperatureEYE.variant">
              <app-label-vehicle
                *ngSwitchCase="'cold'"
                [value]="temperatureEYE.value + ' °C'"
                style="border-radius: 4px; color: #00acc1"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-cold"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
              <app-label-vehicle
                *ngSwitchCase="'hot'"
                [value]="temperatureEYE.value + ' °C'"
                style="border-radius: 4px; color: #e53935"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-hot"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
              <app-label-vehicle
                *ngSwitchCase="'medium'"
                [value]="temperatureEYE.value + ' °C'"
                style="border-radius: 4px; color: #fb8c00"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-medium"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
              <app-label-vehicle
                *ngSwitchDefault
                style="background-color: white; border-radius: 4px"
                title="Temperatura no disponible"
              >
                <i>
                  <svg width="16" height="16" fill="#9e9e9e">
                    <use
                      xlink:href="./assets/icons/sprite.svg#thermometer-disabled"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *appHasPermission="'vehicles_options_teltonika'">
          <ng-container
            *ngIf="
              (servicePanel.showHumidityBle$ | async) &&
              humidityBLE.typeGps === 'teltonika'
            "
          >
            <ng-container [ngSwitch]="humidityBLE.variant">
              <app-label-vehicle
                *ngSwitchCase="'dry'"
                [value]="humidityBLE.value + ' %'"
                style="border-radius: 4px; color: #29b6f6"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-dry"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>

              <app-label-vehicle
                *ngSwitchCase="'normal'"
                [value]="humidityBLE.value + ' %'"
                style="border-radius: 4px; color: #43a047"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-normal"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>

              <app-label-vehicle
                *ngSwitchCase="'humid'"
                [value]="humidityBLE.value + ' %'"
                style="border-radius: 4px; color: #1e88e5"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-humid"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>

              <app-label-vehicle
                *ngSwitchDefault
                style="background-color: white; border-radius: 4px"
                title="Humedad no disponible"
              >
                <i>
                  <svg width="16" height="16" fill="#9e9e9e">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-disabled"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *appHasPermission="'vehicles_options_teltonika'">
          <ng-container
            *ngIf="
              (servicePanel.showHumidityEye$ | async) &&
              humidityEYE.typeGps === 'teltonika'
            "
          >
            <ng-container [ngSwitch]="humidityEYE.variant">
              <app-label-vehicle
                *ngSwitchCase="'dry'"
                [value]="humidityEYE.value + ' %'"
                style="border-radius: 4px; color: #29b6f6"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-dry"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>

              <app-label-vehicle
                *ngSwitchCase="'normal'"
                [value]="humidityEYE.value + ' %'"
                style="border-radius: 4px; color: #43a047"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-normal"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>

              <app-label-vehicle
                *ngSwitchCase="'humid'"
                [value]="humidityEYE.value + ' %'"
                style="border-radius: 4px; color: #1e88e5"
                backgroundColor="#fff"
              >
                <i>
                  <svg width="16" height="16" fill="currentColor">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-humid"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>

              <app-label-vehicle
                *ngSwitchDefault
                style="background-color: white; border-radius: 4px"
                title="Humedad no disponible"
              >
                <i>
                  <svg width="16" height="16" fill="#9e9e9e">
                    <use
                      xlink:href="./assets/icons/sprite.svg#humidity-disabled"
                    ></use>
                  </svg>
                </i>
              </app-label-vehicle>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </main>

    <footer [ngStyle]="{ 'padding-bottom': isExpanded ? '4px' : '8px' }">
      <p *ngIf="servicePanel.showNameDriver$ | async">
        {{ secondInformation }}
      </p>
    </footer>

    <aside *ngIf="isExpanded" class="aside_content">
      <app-summary-details-vehicle
        [titleSummary]="'VEHICLES.CARD.GENERAL.INFO' | translate"
      >
        <ul class="list_details">
          <app-detail-vehicle
            *ngFor="let detail of unitDetails"
            [label]="detail.label"
            [value]="detail.value"
            [variant]="detail.variant"
            (updateNameUnit)="updateNameUnit($event)"
          >
          </app-detail-vehicle>
        </ul>
      </app-summary-details-vehicle>

      <ng-container *appHasPermission="'vehicles_view_parameters'">
        <app-summary-details-vehicle
          titleSummary="Información técnica de tramas (Parámetros)"
        >
          <ul class="list_details">
            <app-detail-vehicle
              *ngFor="let detail of iosDetail"
              [label]="detail.label"
              [value]="detail.value"
              [variant]="detail.variant"
              (updateNameUnit)="updateNameUnit($event)"
            >
            </app-detail-vehicle>
          </ul>
        </app-summary-details-vehicle>
      </ng-container>

      <app-summary-details-vehicle titleSummary="Atajos" [isOpen]="true">
        <div class="grid_buttons">
          <app-square-button-vehicle
            [titleButton]="
              !viewOptionShowDriver
                ? ('VEHICLES.CARD.BUTTON.HIDE.DRIVER' | translate)
                : ('VEHICLES.CARD.BUTTON.SHOW.DRIVER' | translate)
            "
            [isActive]="viewOptionShowDriver"
            (buttonClick)="onClickShowDriver()"
          >
            <span
              class="btn-label"
              [attr.aria-label]="'VEHICLES.CARD.BUTTON.SHOW.DRIVER' | translate"
            >
              <i
                class="fas fa-male fa-lg"
                [ngStyle]="{ color: viewOptionShowDriver ? '#fff' : '#000' }"
              ></i>
            </span>
          </app-square-button-vehicle>
          <app-square-button-vehicle
            [titleButton]="
              !viewOptionShowName
                ? ('VEHICLES.CARD.BUTTON.HIDE.NAME' | translate)
                : ('VEHICLES.CARD.BUTTON.SHOW.NAME' | translate)
            "
            [isActive]="viewOptionShowName"
            (buttonClick)="onClickTag()"
          >
            <span
              _ngcontent-opo-c201=""
              class="btn-label"
              [attr.aria-label]="'VEHICLES.CARD.BUTTON.SHOW.NAME' | translate"
              ><svg
                _ngcontent-opo-c201=""
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24.000000 24.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  _ngcontent-opo-c201=""
                  transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
                  [attr.fill]="viewOptionShowName ? '#fff' : '#000'"
                  stroke="none"
                >
                  <path
                    _ngcontent-opo-c201=""
                    d="M0 165 l0 -75 40 0 c38 0 40 -2 34 -24 -8 -35 4 -66 27 -66 10 0 19
              5 19 10 0 6 11 10 25 10 14 0 25 -4 25 -10 0 -5 9 -10 20 -10 22 0 36 36 25
              69 -5 15 -2 21 9 21 13 0 16 14 16 75 l0 75 -120 0 -120 0 0 -75z m177 58
              c-31 -2 -83 -2 -115 0 -31 2 -5 3 58 3 63 0 89 -1 57 -3z m53 -68 c0 -42 -3
              -55 -15 -55 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -11 10
              -25 10 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5
              -18 -10 -40 -10 l-40 0 0 55 0 55 110 0 110 0 0 -55z m-73 -31 c-3 -3 -12 -4
              -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m41 -31 c3 -10 -12 -13 -52 -13 -51 0
              -66 7 -50 23 11 11 97 2 102 -10z m-5 -30 c-7 -2 -13 -11 -13 -19 0 -9 -12
              -14 -36 -14 -27 0 -35 4 -31 14 4 9 -1 17 -11 19 -9 3 10 5 43 5 33 0 54 -2
                48 -5z"
                  ></path>
                  <path
                    _ngcontent-opo-c201=""
                    d="M20 165 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35 -33
              0 -35 -2 -35 -35z m60 10 c0 -7 -11 -12 -25 -12 -14 0 -25 5 -25 12 0 7 11 13
              25 13 14 0 25 -6 25 -13z m-7 -32 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19
              -2 13 -5z"
                  ></path>
                  <path
                    _ngcontent-opo-c201=""
                    d="M153 193 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
                  ></path>
                  <path
                    _ngcontent-opo-c201=""
                    d="M138 173 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
                  ></path>
                  <path
                    _ngcontent-opo-c201=""
                    d="M138 153 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
                  ></path>
                  <path
                    _ngcontent-opo-c201=""
                    d="M33 113 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -17 0 -22 -2 -12 -5z"
                  ></path>
                </g></svg
            ></span>
          </app-square-button-vehicle>
          <app-square-button-vehicle
            [titleButton]="
              viewOptionFollow
                ? ('VEHICLES.CARD.BUTTON.HIDE.FOLLOW' | translate)
                : ('VEHICLES.CARD.BUTTON.SHOW.FOLLOW' | translate)
            "
            [isActive]="viewOptionFollow"
            (buttonClick)="onClickFollow()"
          >
            <svg
              _ngcontent-ldu-c198=""
              _ngcontent-opo-c203=""
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              [ngStyle]="{ color: viewOptionFollow ? '#fff' : '#000' }"
              [attr.fill]="viewOptionFollow ? '#fff' : '#000'"
            >
              <path
                _ngcontent-ldu-c198=""
                _ngcontent-opo-c203=""
                d="M9.5 10.287c0-.41-.336-.743-.75-.743s-.75.333-.75.743.336.743.75.743.75-.333.75-.743zm4.5.495c0-.137-.112-.248-.25-.248h-3.5c-.138 0-.25.111-.25.248s.112.248.25.248h3.5c.138-.001.25-.112.25-.248zm2-.495c0-.41-.336-.743-.75-.743s-.75.333-.75.743.336.743.75.743.75-.333.75-.743zm-8.649-3.219h-1.101c-.138 0-.25.111-.25.248v.253c0 .393.463.49.808.49l.543-.991zm9.659 1.569c-.435-.8-.866-1.597-1.342-2.382-.393-.649-.685-.96-1.375-1.083-.698-.124-1.341-.172-2.293-.172s-1.595.048-2.292.172c-.69.123-.982.433-1.375 1.083-.477.785-.907 1.582-1.343 2.382-.344.63-.49 1.194-.49 1.884 0 .653.21 1.195.5 1.89v1.094c0 .273.224.495.5.495h.75c.276 0 .5-.222.5-.495v-.495h6.5v.495c0 .273.224.495.5.495h.75c.276 0 .5-.222.5-.495v-1.094c.29-.695.5-1.237.5-1.89 0-.69-.146-1.254-.49-1.884zm-7.821-1.873c.335-.554.426-.569.695-.617.635-.113 1.228-.157 2.116-.157s1.481.044 2.116.156c.269.048.36.064.695.617.204.337.405.687.597 1.03-.728.11-2.01.266-3.408.266-1.524 0-2.759-.166-3.402-.275.19-.34.389-.686.591-1.02zm5.798 5.256h-5.974c-.836 0-1.513-.671-1.513-1.498 0-.813.253-1.199.592-1.821.52.101 1.984.348 3.908.348 1.74 0 3.28-.225 3.917-.333.332.609.583.995.583 1.805 0 .828-.677 1.499-1.513 1.499zm2.763-4.952c.138 0 .25.111.25.248v.253c0 .393-.463.49-.808.49l-.543-.99h1.101zm-5.75-7.068c-5.523 0-10 4.394-10 9.815 0 5.505 4.375 9.268 10 14.185 5.625-4.917 10-8.68 10-14.185 0-5.421-4.478-9.815-10-9.815zm0 18c-4.419 0-8-3.582-8-8s3.581-8 8-8c4.419 0 8 3.582 8 8s-3.581 8-8 8z"
              ></path>
            </svg>
          </app-square-button-vehicle>
          <app-square-button-vehicle
            [titleButton]="
              viewOptionVisible
                ? ('VEHICLES.CARD.BUTTON.HIDE.UNIT' | translate)
                : ('VEHICLES.CARD.BUTTON.SHOW.UNIT' | translate)
            "
            [isActive]="!viewOptionVisible"
            (buttonClick)="onClickEye()"
          >
            <svg
              *ngIf="viewOptionVisible"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#000"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-eye"
            >
              <path
                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
              />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <svg
              *ngIf="!viewOptionVisible"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-eye-off"
            >
              <path
                d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
              />
              <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
              <path
                d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
              />
              <path d="m2 2 20 20" />
            </svg>
          </app-square-button-vehicle>

          <!-- <app-square-button-vehicle
          titleButton="Proximamente..."
          [isDisabled]="true"
        >
          <span _ngcontent-opo-c205="" class="btn-label"
            ><svg
              _ngcontent-opo-c205=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="20"
              height="20"
            >
              <path
                _ngcontent-opo-c205=""
                fill="#00000044"
                d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4 .4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
              ></path></svg
          ></span>
        </app-square-button-vehicle> -->
        </div>
      </app-summary-details-vehicle>
    </aside>

    <div
      *ngIf="withOpenClose"
      class="icon_open_close"
      [class.icon_rotate]="isExpanded"
      (click)="toggleCardVisibility($event)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m19.5 8.25-7.5 7.5-7.5-7.5"
        />
      </svg>
    </div>

    <div *ngIf="servicePanel.showIconVehicle$ | async" class="image_container">
      <img
        [src]="urlIcon"
        class="image"
        width="32"
        height="32"
        decoding="async"
        loading="lazy"
        [alt]="unitType"
      />
    </div>

    <ul *ngIf="!isExpanded && withActionButton" class="card_actions">
      <li *ngIf="servicePanel.showHistoryButton$ | async">
        <button
          class="action_button"
          (click)="stopEvent($event)"
          (click)="onClickShowHistory()"
          (mouseenter)="onMouseEnter('history')"
          (mouseleave)="onMouseLeave('history')"
        >
          <app-tooltip-for-footer-card
            *ngIf="isShowTooltipHistory"
            label="Recorrido hoy"
          ></app-tooltip-for-footer-card>
          <span
            _ngcontent-ocn-c203=""
            class="btn-label"
            attr.aria-label="Recorrido hoy"
          >
            <!-- <svg width="16" height="16" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#history"></use>
            </svg> -->
            <mat-icon size="18">history</mat-icon>
          </span>
        </button>
      </li>

      <ng-container *appHasPermission="'vehicles_send_command'">
        <li *ngIf="servicePanel.showCommandButton$ | async" class="command-menu">
          <!-- Botón principal -->
          <ng-container
            *ngIf="broadcastService.getCommands(IMEI).length == 0; else CMDs"
          >
            <button
              class="action_button command-main"
              (click)="stopEvent($event)"
              (mouseenter)="onMouseEnter('command')"
              (mouseleave)="onMouseLeave('command')"
            >
              <app-tooltip-for-footer-card
                *ngIf="isShowTooltipCommand"
                label="Sin comandos"
              ></app-tooltip-for-footer-card>

              <span class="btn-label" aria-label="Sin comandos">
                <mat-icon>code_off</mat-icon>
              </span>
            </button>
          </ng-container>
          <!-- Botones de comandos -->
          <ng-template #CMDs>
            <div class="command-items d-flex">
              <button
                *ngFor="let item of broadcastService.getCommands(IMEI)"
                class="action_button command-item"
                (click)="stopEvent($event)"
                (click)="onClickEmmitCommand(item, unitDetails)"
                (mouseenter)="onMouseEnter('command')"
                (mouseleave)="onMouseLeave('command')"
              >
                <app-tooltip-for-footer-card
                  class="command-tooltip"
                  *ngIf="isShowTooltipCommand"
                  [label]="item.description"
                ></app-tooltip-for-footer-card>
                <span class="btn-label" [attr.aria-label]="item.label">
                  <mat-icon>settings_ethernet</mat-icon>
                </span>

                <span class="command-text">
                  {{ item.label }}
                </span>
              </button>
            </div>
          </ng-template>
        </li>
      </ng-container>

      <li
        *ngIf="servicePanel.showDriverButton$ | async"
        [class.action_button_li_active]="viewOptionShowDriver"
      >
        <button
          class="action_button"
          [class.action_button_active]="viewOptionShowDriver"
          (click)="stopEvent($event)"
          (click)="onClickShowDriver()"
          (mouseenter)="onMouseEnter('driver')"
          (mouseleave)="onMouseLeave('driver')"
        >
          <app-tooltip-for-footer-card
            *ngIf="isShowTooltipDriver"
            [label]="
              (viewOptionShowDriver
                ? 'VEHICLES.CARD.BUTTON.HIDE.DRIVER'
                : 'VEHICLES.CARD.BUTTON.SHOW.DRIVER'
              ) | translate
            "
          ></app-tooltip-for-footer-card>
          <span
            _ngcontent-ocn-c203=""
            class="btn-label"
            [attr.aria-label]="'VEHICLES.CARD.BUTTON.SHOW.DRIVER' | translate"
            ><i
              _ngcontent-ocn-c203=""
              class="fas fa-male fa-lg"
              style="color: inherit"
            ></i
          ></span>
        </button>
      </li>

      <li
        *ngIf="servicePanel.showNameButton$ | async"
        [class.action_button_li_active]="viewOptionShowName"
      >
        <button
          class="action_button"
          [class.action_button_active]="viewOptionShowName"
          (click)="stopEvent($event)"
          (click)="onClickTag()"
          (mouseenter)="onMouseEnter('tag')"
          (mouseleave)="onMouseLeave('tag')"
        >
          <app-tooltip-for-footer-card
            *ngIf="isShowTooltipTag"
            [label]="
              (isShowDriver
                ? 'VEHICLES.CARD.BUTTON.HIDE.NAME'
                : 'VEHICLES.CARD.BUTTON.SHOW.NAME'
              ) | translate
            "
          ></app-tooltip-for-footer-card>
          <span
            _ngcontent-opo-c201=""
            class="btn-label"
            [attr.aria-label]="'VEHICLES.CARD.BUTTON.SHOW.NAME' | translate"
            ><svg
              _ngcontent-opo-c201=""
              version="1.0"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24.000000 24.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                _ngcontent-opo-c201=""
                transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
                fill="currentColor"
                stroke="none"
              >
                <path
                  _ngcontent-opo-c201=""
                  d="M0 165 l0 -75 40 0 c38 0 40 -2 34 -24 -8 -35 4 -66 27 -66 10 0 19
            5 19 10 0 6 11 10 25 10 14 0 25 -4 25 -10 0 -5 9 -10 20 -10 22 0 36 36 25
            69 -5 15 -2 21 9 21 13 0 16 14 16 75 l0 75 -120 0 -120 0 0 -75z m177 58
            c-31 -2 -83 -2 -115 0 -31 2 -5 3 58 3 63 0 89 -1 57 -3z m53 -68 c0 -42 -3
            -55 -15 -55 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -11 10
            -25 10 -14 0 -25 -4 -25 -10 0 -5 -7 -10 -15 -10 -8 0 -15 -4 -15 -10 0 -5
            -18 -10 -40 -10 l-40 0 0 55 0 55 110 0 110 0 0 -55z m-73 -31 c-3 -3 -12 -4
            -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m41 -31 c3 -10 -12 -13 -52 -13 -51 0
            -66 7 -50 23 11 11 97 2 102 -10z m-5 -30 c-7 -2 -13 -11 -13 -19 0 -9 -12
            -14 -36 -14 -27 0 -35 4 -31 14 4 9 -1 17 -11 19 -9 3 10 5 43 5 33 0 54 -2
                48 -5z"
                ></path>
                <path
                  _ngcontent-opo-c201=""
                  d="M20 165 c0 -33 2 -35 35 -35 33 0 35 2 35 35 0 33 -2 35 -35 35 -33
            0 -35 -2 -35 -35z m60 10 c0 -7 -11 -12 -25 -12 -14 0 -25 5 -25 12 0 7 11 13
            25 13 14 0 25 -6 25 -13z m-7 -32 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19
            -2 13 -5z"
                ></path>
                <path
                  _ngcontent-opo-c201=""
                  d="M153 193 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"
                ></path>
                <path
                  _ngcontent-opo-c201=""
                  d="M138 173 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
                ></path>
                <path
                  _ngcontent-opo-c201=""
                  d="M138 153 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
                ></path>
                <path
                  _ngcontent-opo-c201=""
                  d="M33 113 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -17 0 -22 -2 -12 -5z"
                ></path>
              </g></svg
          ></span>
        </button>
      </li>

      <li
        *ngIf="servicePanel.showFollowUnitButton$ | async"
        [class.action_button_li_active]="viewOptionFollow"
      >
        <button
          class="action_button"
          [class.action_button_active]="viewOptionFollow"
          (click)="stopEvent($event)"
          (click)="onClickFollow($event)"
          (mouseenter)="onMouseEnter('follow')"
          (mouseleave)="onMouseLeave('follow')"
        >
          <app-tooltip-for-footer-card
            *ngIf="isShowTooltipFollow"
            [label]="
              isFollowUnit
                ? ('VEHICLES.CARD.BUTTON.HIDE.FOLLOW' | translate)
                : ('VEHICLES.CARD.BUTTON.SHOW.FOLLOW' | translate)
            "
          ></app-tooltip-for-footer-card>
          <svg
            _ngcontent-ldu-c198=""
            _ngcontent-opo-c203=""
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            style="color: inherit"
            fill="currentColor"
          >
            <path
              _ngcontent-ldu-c198=""
              _ngcontent-opo-c203=""
              d="M9.5 10.287c0-.41-.336-.743-.75-.743s-.75.333-.75.743.336.743.75.743.75-.333.75-.743zm4.5.495c0-.137-.112-.248-.25-.248h-3.5c-.138 0-.25.111-.25.248s.112.248.25.248h3.5c.138-.001.25-.112.25-.248zm2-.495c0-.41-.336-.743-.75-.743s-.75.333-.75.743.336.743.75.743.75-.333.75-.743zm-8.649-3.219h-1.101c-.138 0-.25.111-.25.248v.253c0 .393.463.49.808.49l.543-.991zm9.659 1.569c-.435-.8-.866-1.597-1.342-2.382-.393-.649-.685-.96-1.375-1.083-.698-.124-1.341-.172-2.293-.172s-1.595.048-2.292.172c-.69.123-.982.433-1.375 1.083-.477.785-.907 1.582-1.343 2.382-.344.63-.49 1.194-.49 1.884 0 .653.21 1.195.5 1.89v1.094c0 .273.224.495.5.495h.75c.276 0 .5-.222.5-.495v-.495h6.5v.495c0 .273.224.495.5.495h.75c.276 0 .5-.222.5-.495v-1.094c.29-.695.5-1.237.5-1.89 0-.69-.146-1.254-.49-1.884zm-7.821-1.873c.335-.554.426-.569.695-.617.635-.113 1.228-.157 2.116-.157s1.481.044 2.116.156c.269.048.36.064.695.617.204.337.405.687.597 1.03-.728.11-2.01.266-3.408.266-1.524 0-2.759-.166-3.402-.275.19-.34.389-.686.591-1.02zm5.798 5.256h-5.974c-.836 0-1.513-.671-1.513-1.498 0-.813.253-1.199.592-1.821.52.101 1.984.348 3.908.348 1.74 0 3.28-.225 3.917-.333.332.609.583.995.583 1.805 0 .828-.677 1.499-1.513 1.499zm2.763-4.952c.138 0 .25.111.25.248v.253c0 .393-.463.49-.808.49l-.543-.99h1.101zm-5.75-7.068c-5.523 0-10 4.394-10 9.815 0 5.505 4.375 9.268 10 14.185 5.625-4.917 10-8.68 10-14.185 0-5.421-4.478-9.815-10-9.815zm0 18c-4.419 0-8-3.582-8-8s3.581-8 8-8c4.419 0 8 3.582 8 8s-3.581 8-8 8z"
            ></path>
          </svg>
        </button>
      </li>

      <ng-container *ngIf="withActionButton">
        <li
          *ngIf="servicePanel.showEyeButton$ | async"
          [class.action_button_li_active]="!viewOptionVisible"
        >
          <button
            class="action_button"
            [class.action_button_active]="!viewOptionVisible"
            (click)="stopEvent($event)"
            (click)="onClickEye()"
            (mouseenter)="onMouseEnter('eye')"
            (mouseleave)="onMouseLeave('eye')"
          >
            <app-tooltip-for-footer-card
              *ngIf="isShowTooltipEye"
              [label]="
                !isShowEye
                  ? ('VEHICLES.CARD.BUTTON.HIDE.UNIT' | translate)
                  : ('VEHICLES.CARD.BUTTON.SHOW.UNIT' | translate)
              "
            ></app-tooltip-for-footer-card>
            <svg
              *ngIf="viewOptionVisible"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-eye"
            >
              <path
                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
              />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <svg
              *ngIf="!viewOptionVisible"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.75"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-eye-off"
            >
              <path
                d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
              />
              <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
              <path
                d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
              />
              <path d="m2 2 20 20" />
            </svg>
          </button>
        </li>
      </ng-container>

      <!-- <li *ngIf="servicePanel.getShowConfigurationButton()">
      <button
        class="action_button"
        (click)="stopEvent($event)"
        title="Configurar Unidad"
        (mouseenter)="onMouseEnter('edit')"
        (mouseleave)="onMouseLeave('edit')"
      >
        <app-tooltip-for-footer-card
          *ngIf="isShowTooltipEdit"
          label="Configurar Unidad"
        ></app-tooltip-for-footer-card>
        <span _ngcontent-opo-c205="" class="btn-label"
          ><svg
            _ngcontent-opo-c205=""
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width="16"
            height="16"
          >
            <path
              _ngcontent-opo-c205=""
              fill="currentColor"
              d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4 .4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
            ></path></svg
        ></span>
      </button>
    </li> -->
    </ul>
  </article>
</div>
